import Vue from 'vue'
import VueMeta from 'vue-meta'
import app from './App.vue'
import router from "./router"
import store from "./store/store";
import components from './components/components-template'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

import Axios from 'axios'
Vue.prototype.$http = Axios;

//Template
import './assets/css/template.css'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//Tradução
import VueTranslate from 'vue-translate-plugin';
import Locales from "./locales"

//Validação
import Vuelidate from 'vuelidate'

//Gráficos
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

import {
    ValidationObserver,
    ValidationProvider,
    extend,
    localize
} from "vee-validate";

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import * as rules from "vee-validate/dist/rules";

localize("pt_BR", pt_BR);

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

import './validate/customRules'

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

//Fragment para utilização de elemento raiz sem div
import {Plugin} from 'vue-fragment'

//Filtros
import './filters/filters-template'

Vue.use(require('vue-moment'));

import { Twitter, Sketch } from 'vue-color'
Vue.component('twitter-picker',Twitter)
Vue.component('sketch-picker',Sketch)

//Mascaras
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import money from 'v-money'
Vue.use(money);
//---


Vue.use(Plugin)
Vue.use(VueMeta)
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueTranslate)
Vue.use(components)


//Utililizar
Vue.config.productionTip = false
Vue.locales(Locales);

new Vue({
    store,
    router,
    render: h => h(app),
}).$mount('#app')
